export type ReviewerWindowKey = "7-days" | "30-days" | "90-days" | "all-time";

export const REVIEWER_WINDOW_OPTIONS: ReadonlyArray<{
  key: ReviewerWindowKey;
  label: string;
  days: number | null;
}> = [
  { key: "7-days", label: "7 days", days: 7 },
  { key: "30-days", label: "30 days", days: 30 },
  { key: "90-days", label: "90 days", days: 90 },
  { key: "all-time", label: "All time", days: null },
];

export const DEFAULT_REVIEWER_WINDOW: ReviewerWindowKey = "30-days";

const DAY_MS = 24 * 60 * 60 * 1000;

export const parseReviewerWindow = (
  value: string | null | undefined,
): ReviewerWindowKey | null =>
  REVIEWER_WINDOW_OPTIONS.find((option) => option.key === value)?.key ?? null;

export const reviewerWindowDays = (key: ReviewerWindowKey): number | null =>
  REVIEWER_WINDOW_OPTIONS.find((option) => option.key === key)?.days ?? null;

export const reviewerWindowStart = (
  key: ReviewerWindowKey,
  now: number,
): number | null => {
  const days = reviewerWindowDays(key);
  return days === null ? null : now - days * DAY_MS;
};

export const isWithinReviewerWindow = (
  at: string | null | undefined,
  windowStart: number | null,
): boolean => {
  if (at === null || at === undefined) return false;
  const time = new Date(at).getTime();
  if (!Number.isFinite(time)) return false;
  return windowStart === null || time >= windowStart;
};

export const reviewerWindowLabel = (key: ReviewerWindowKey): string => {
  const days = reviewerWindowDays(key);
  return days === null ? "all time" : `last ${days} days`;
};
